import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiHeart, FiTrash2, FiShoppingCart } from 'react-icons/fi';
import { useWishlistStore, useCartStore, useUIStore } from '../store';
import { formatPrice } from '../utils/helpers';
import SEO from '../components/common/SEO';
import ContactCTA from '../components/common/ContactCTA';
import toast from 'react-hot-toast';

const WishlistPage = () => {
  const { items, toggle } = useWishlistStore();
  const { addItem } = useCartStore();
  const { setCartOpen } = useUIStore();

  const handleMoveToCart = (item) => {
    addItem(item, 1);
    toggle(item);
    setCartOpen(true);
    toast.success('Moved to cart!');
  };

  return (
    <>
      <SEO title="My Wishlist" />
      <div className="bg-[#0f2347] py-10">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="font-display text-3xl font-black text-white">My Wishlist</h1>
          <p className="text-white/60 text-sm mt-1">{items.length} saved items</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        {items.length === 0 ? (
          <div className="text-center py-24">
            <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <FiHeart className="w-10 h-10 text-gray-300" />
            </div>
            <h2 className="font-display text-2xl font-bold text-gray-800 mb-2">Your wishlist is empty</h2>
            <p className="text-gray-500 mb-6">Save items you love for later</p>
            <Link to="/shop" className="btn-primary inline-block">Browse Products</Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5">
            {items.map((item, i) => (
              <motion.div key={item.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }} className="bg-white group shadow-card hover:shadow-hover transition-all duration-500">
                <div className="relative overflow-hidden aspect-square">
                  <Link to={`/product/${item.id}`}>
                    <img src={item.images?.[0] || 'https://via.placeholder.com/300?text=Chair'} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" onError={e => e.target.src = 'https://via.placeholder.com/300?text=Chair'} />
                  </Link>
                  <button onClick={() => { toggle(item); toast.success('Removed from wishlist'); }} className="absolute top-3 right-3 w-8 h-8 bg-white shadow flex items-center justify-center text-red-500 hover:bg-red-500 hover:text-white transition-all">
                    <FiTrash2 className="w-3.5 h-3.5" />
                  </button>
                </div>
                <div className="p-4">
                  <Link to={`/product/${item.id}`}>
                    <h3 className="font-semibold text-sm text-gray-900 hover:text-[#1a3a6e] transition-colors line-clamp-2 mb-2">{item.title}</h3>
                  </Link>
                  <div className="flex items-center justify-between">
                    <span className="font-black text-[#1a3a6e]">{formatPrice(item.salePrice || item.price)}</span>
                    <button onClick={() => handleMoveToCart(item)} className="w-8 h-8 bg-[#1a3a6e] text-white flex items-center justify-center hover:bg-[#e63946] transition-colors">
                      <FiShoppingCart className="w-3.5 h-3.5" />
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
      <ContactCTA />
    </>
  );
};

export default WishlistPage;
